/** Hosts the Capacitor WebView may navigate to (instead of the system browser). */
export const STATIC_ALLOWED_NAVIGATION_HOSTS = [
  "komut.app",
  "www.komut.app",
  "checkout.stripe.com",
  "js.stripe.com",
  "pay.stripe.com",
  "billing.stripe.com",
  "accounts.google.com",
  "www.google.com",
] as const;

function hostFromUrl(value: string | undefined): string | null {
  if (!value) return null;
  try {
    return new URL(value).hostname;
  } catch {
    return null;
  }
}

/** Build allow-list from Vite env (runtime) or process.env (cap sync). */
export function getAllowedNavigationHosts(
  env: Record<string, string | undefined>,
): string[] {
  const hosts = new Set<string>(STATIC_ALLOWED_NAVIGATION_HOSTS);

  for (const key of [
    "VITE_MARKETING_URL",
    "VITE_APP_URL",
    "VITE_SUPABASE_URL",
  ] as const) {
    const hostname = hostFromUrl(env[key]);
    if (hostname) hosts.add(hostname);
  }

  return [...hosts];
}

export function isAllowedNavigationHost(
  hostname: string,
  env: Record<string, string | undefined>,
): boolean {
  const normalized = hostname.toLowerCase();
  return getAllowedNavigationHosts(env).some(
    (allowed) =>
      normalized === allowed.toLowerCase() ||
      normalized.endsWith(`.${allowed.toLowerCase()}`),
  );
}

/** wa.me / tel: etc. should still open the native app or dialer. */
export function isExternalAppLink(href: string, hostname: string): boolean {
  if (/^(tel:|mailto:|sms:|geo:|whatsapp:)/i.test(href)) return true;
  const host = hostname.toLowerCase();
  return host === "wa.me" || host.endsWith("whatsapp.com");
}
